module.exports = __webpack_public_path__ + "assets/img/logo-frame-tablet.3f814b51.png";